<template>
    <div class="top_con">
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"  max-height="580px">
            <el-table-column prop="id"  label="序号"></el-table-column>
            <el-table-column prop="mid"  label="评价名单ID"></el-table-column>
            <el-table-column prop="name"  label="评论名单"></el-table-column>
            <el-table-column prop="cont"  label="评论内容" ></el-table-column>
            <el-table-column   label="状态">
                <template slot-scope="scope">
                   <span v-if="scope.row.auditstatus==1">待审核</span>
                   <span v-if="scope.row.auditstatus==2">审核通过</span>
                   <span v-if="scope.row.auditstatus==3">审核驳回</span>
                </template>
            </el-table-column>
            <el-table-column prop="sh_user"  label="审核人" ></el-table-column>
            <el-table-column prop="address"  label="操作">
                <template slot-scope="scope">
                    <div  v-if="sh==true && scope.row.auditstatus==1" style="display:inline-block">
                         <el-link :underline="false" @click="TG(scope.row.id)" style="margin-right:20px;" size="small">审核通过</el-link>
                         <el-link :underline="false" @click="JU(scope.row.id)" style="margin-right:20px;" size="small">审核拒绝</el-link>
                    </div>
                    <el-link  type="danger" :underline="false" @click="Del(scope.row.id)" size="small" v-if="dels==true">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>
<script>
import {getPJList,getPJList_tg,getPJList_bh,getPJList_del} from '@/utils/api'
export default {
    data(){
        return{
            houseLis:[],
            formInline: {
                numbers:'',
                prodName:'',
                wid:'',
                sPrice:'',
                price:'',
                fit:'',
            },
            roleid:'',
            dialogFormVisible:false,
            chuKu:false,
            formLabelWidth: '120px',
            value:10,
            total:10,
            multipleSelection:[],
            tableData: [],
            pageNum:1,
            avg_pro:'',
            sh:false,
            dels:false,
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                userId:this.user.uid,
                numPerPage:this.value,
                pageNum:this.pageNum,
            } 
            getPJList(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
                this.sh=res.qx.sh;
                this.dels=res.qx.dels;
            });
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        Del(id){
            this.$confirm('确定删除, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let user=JSON.parse(localStorage.getItem('userInfo'))
                    let param ={
                        userId:this.user.uid,
                        rId:id
                    }
                    getPJList_del(param).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getPJList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.sh=res.qx.sh;
                            this.dels=res.qx.dels;
                        });
                    });
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        JU(id){
            this.$confirm('确定拒绝, 是否继续?', '拒绝', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let user=JSON.parse(localStorage.getItem('userInfo'))
                    let param ={
                        userId:this.user.uid,
                        rId:id
                    }
                    getPJList_bh(param).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getPJList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.sh=res.qx.sh;
                            this.dels=res.qx.dels;
                        });
                    });
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        TG(id){
            this.$confirm('确定通过, 是否继续?', '通过', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let param ={
                        userId:this.user.uid,
                        rId:id
                    }
                    getPJList_tg(param).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getPJList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.sh=res.qx.sh;
                            this.dels=res.qx.dels;
                        });
                    });
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            userId:this.user.uid,
            numPerPage:this.value,
            pageNum:this.pageNum,
        } 
        getPJList(param).then(res=>{
            this.total=res.total;
            this.tableData=res.list;
            this.sh=res.qx.sh;
            this.dels=res.qx.dels;
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Stock.vue